export function isAuthenticated() {
  return !!localStorage.getItem("att_data");
}